import React, { useEffect, useState } from 'react';
import { Layout, Row, Col, Typography, Space, Avatar, Dropdown, Menu, Modal, Button, message, Spin, Select, Form } from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  QuestionCircleOutlined,
  BellOutlined,
  ExclamationCircleOutlined,
  UserSwitchOutlined,
  SwapOutlined
} from '@ant-design/icons';
import { useHistory, useLocation } from 'react-router-dom';
import { routes } from '../../routes/Routes';
import { SESSION_TOKEN, COMMON_ERROR_MSG } from '../../constants/constants';
import _NewapplicationService from '../../modules/NewapplicationService';
import SelectBankDDL from './SelectBankDDL';

const { Header } = Layout;
const { Text } = Typography;
const { confirm } = Modal;
const { Option } = Select;
const PageHeader = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const showLogoutConfirm = () => {
    confirm({
      title: `Are you sure you want to Logout?`,
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        onLogoutOkClick();
      },
    });
  };

  const onLogoutOkClick = async () => {
    localStorage.clear();
    window.sessionStorage.clear();
    history.push(routes.registeredEmail.path);
  };

  const switchToFirmAdmin = async () => {
    let reqObj = {
      Email: localStorage.getItem("loginEmail") ? localStorage.getItem("loginEmail") : localStorage.getItem("ApplicationEmailId"),
      Password: localStorage.getItem("IsKey"),
      IsFirmAdmin: true,
    }
    setLoading(true);
    try {
      const res = await _NewapplicationService.userLogin(reqObj);
      if (res.data.IsSuccess) {
        setLoading(false);
        localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
        localStorage.setItem("userRole", res?.data?.Obj?.Role);
        localStorage.setItem("IsFirmAdminFlag", res?.data?.Obj?.IsFirmAdmin);
        localStorage.setItem("HasOtherRoleAssociation", res?.data?.Obj?.HasOtherRoleAssociation);
        localStorage.setItem("SponserIdForFirmLogin", res?.data?.Obj?.SponserId);
        localStorage.setItem("ApplicationEmailId", res?.data?.Obj?.Email);
        localStorage.setItem("ApplicationId", res?.data?.Obj?.Id);
        localStorage.setItem("BankerId", res?.data?.Obj?.BankerId);
        localStorage.setItem("loginEmail", reqObj.Email);
        localStorage.setItem("IsKey", reqObj.Password);
        localStorage.setItem("IsSwitchFirmAdmin", JSON.stringify(true));
        history.push({
          pathname: routes.firmadmindashboard.path,
          state: { "email": reqObj.Email }
        });
      } else {
        setLoading(false);
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined style={{ transform: 'rotate(-90deg)' }} />} onClick={showLogoutConfirm}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Spin spinning={loading}>
      <Header
        style={{
          background: '#193a6a',
          height: 72,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          boxShadow: '0 2px 8px rgba(25,58,106,0.04)',
          zIndex: 10,
          width: '100%',
        }}
      >
        <Row
          align="middle"
          justify="center"
          style={{ width: '100%', height: '100%' }}
        >
          <Col
            xs={24}
            style={{
              margin: '0 auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '100%',
            }}
            className='containerwidth'
          >
            <Space align="center">
              {/* Replace with your logo path */}
              <img src="/SiteLogo11.svg" alt="LEVRIDGE.AI" style={{ height: 36 , marginLeft:"5px"}} />

            </Space>
            <Space size="middle" className='primaryButtonColor'>
              {/* <Avatar size="small" icon={<BellOutlined />} style={{ backgroundColor: "#fff", color: "#193a6a" }} /> */}
              {/* <Avatar size="small" icon={<UserOutlined />} style={{ backgroundColor: "#fff", color: "#193a6a" }} /> */}

              {localStorage.getItem("IsFirmAdminFlag") === "true" && (
                <Button
                  type="primary"
                  icon={<UserSwitchOutlined />}  
                  onClick={switchToFirmAdmin}
                >
                  Switch to Firm Admin
                </Button>
              )}

              {/* {location.pathname === routes.myApplications.path && (
                <SelectBankDDL />
              )} */}

              <Dropdown overlay={menu} placement="bottomRight">
                <Space style={{ color: "#fff", cursor: "pointer",marginRight:"12px"}}>
                  <Avatar size="small" icon={<LogoutOutlined style={{ transform: 'rotate(-90deg)' }} />} style={{ backgroundColor: "#fff", color: "#193a6a"}} />
                  Logout
                </Space>
              </Dropdown>
            </Space>
          </Col>
        </Row>
      </Header>
    </Spin>
  )
};

export default PageHeader;